export function selectPhoto(index, selectedPhotos, photos) {
  if (selectedPhotos.length > index) return selectedPhotos[index];
  return photos[index % photos.length];
}

export const extractCollId = (collectionId) => collectionId.substring(collectionId.lastIndexOf('/') + 1); // alternative getShopifyCollections().find(id => collectionId.includes(id))
